import styled from "@mui/material/styles/styled";

import { Column, StackProps } from "@rui/Stack";

interface DropContainerProps extends StackProps {
  hovering?: boolean;
  disabled?: boolean;
}

const DropContainer = styled(
  ({ hovering: _, disabled: _d, ...props }: DropContainerProps) => (
    <Column variant="center" spacing={2} {...props} />
  )
)(({ theme, hovering, disabled }) => ({
  borderRadius: "8px",
  padding: "14px",
  backgroundColor: theme.palette.background.default,
  // https://kovart.github.io/dashed-border-generator/
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23A3A3A3' stroke-width='1' stroke-dasharray='6%2c 9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,

  ...(hovering && {
    backgroundColor: theme.palette.shades.secondary[50],
    border: `2px solid ${theme.palette.shades.secondary[500]}`,
    padding: "12px",
    backgroundImage: "none",
  }),

  ...(disabled && {
    backgroundColor: theme.palette.shades.neutral[50],
    border: `1px solid ${theme.palette.shades.neutral[50]}`,
    padding: "14px",
    backgroundImage: "none",
  }),
}));

export default DropContainer;
